import { updateMealImageURL } from "../index";

export default function UpdateMealImageUrlFunc(mealId: any,
  URL:string) {
    const reqBody = {
      imageURL: URL
    };
  return updateMealImageURL(mealId,reqBody)
}
